import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 shadow-lg transition-all duration-300 cursor-pointer"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}